import { ServicePageTemplate } from "@/components/services/ServicePageTemplate";
import { servicePages } from "@/data/servicePages";

const data = servicePages.find((s) => s.slug === "provisional-tax-returns")!;
const ProvisionalTaxReturns = () => <ServicePageTemplate data={data} />;
export default ProvisionalTaxReturns;
